'use strict'

module.exports = (config) => {
  return () => ({
    host: config.host,
    port: config.port
  })
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ipfs-api/src/util/get-endpoint-config.js
// module id = Kwi/
// module chunks = 0